import { Injectable } from '@angular/core';
import {Store, Action} from '@ngrx/store';
import {Response, Headers, RequestOptionsArgs, RequestOptions, Http} from '@angular/http';
import {UNDO_ACTION} from 'ngrx-undo';

import * as authenticationTypes from '../../authentication/types';
import { IApplicationState } from '../../stateManagement/states/applicationState';
import * as fromRoot from '../../stateManagement/rootReducer';

import { LOCALSTORAGE_AUTH } from '../../../setup/configurations';
import * as _ from 'lodash';
import * as applicationActions from '../../stateManagement/actions/containers/application';
import * as commonTypes from '../types';
import { DisableBusyFlag } from '../../stateManagement/actions/containers/application';
import { go, replace, search, show, back, forward } from '@ngrx/router-store';
import { ServerLogoutAction } from '../../stateManagement/actions/data/authentication';

@Injectable()
export class BaseHttpService {
  protected jwtToken: string;
  protected userId: number;
  protected starterId: number;
  protected stageId:  number ;
  protected starterIds: string;
  protected inducteeId: number;
  protected inducteeIds: string;
  protected offboardeeId: number;
  protected offboardeeIds: string;
  protected type: string ; // starter | inductee | offboardee
  protected typeId: number ; // 963 | 28 | 152
  protected taskId: number = 0;
  protected starterFirstName: string; 
  protected starterSurname: string;
  protected offboardeeFirstName: string; 
  protected offboardeeSurname: string;
  protected welcomemessage: any; 
  
  constructor(private store: Store<IApplicationState>) {
    this.store.select(fromRoot.getStageDataCurrentStageId).subscribe((stageId: number) => this.stageId = stageId);
    this.store.select(fromRoot.getAuthenticationJwtToken).subscribe((jwtToken: string) => this.jwtToken = jwtToken);
    this.store.select(fromRoot.getAuthenticationAccount).subscribe((account: authenticationTypes.IAccount) => {
      if (account) {
        this.userId = account.userID;
        this.starterFirstName = account.starterFirstName; 
        this.starterSurname = account.starterSurname; 
        this.offboardeeFirstName = account.offboardeeFirstName; 
        this.offboardeeSurname = account.offboardeeSurname; 
        this.starterId = account.starterID;
        this.starterIds = account.starters;
        this.offboardeeIds = account.offboardees;
        this.offboardeeId = account.offboardeeID;
        this.userId = account.userID;
        this.starterIds = account.starters;
        this.inducteeId = account.inducteeID;
        this.welcomemessage = account.welcomemessage;  
      }
    });
    //  this.store.select(fromRoot.getAuthenticationJwtToken).subscribe((jwtToken: string) => this.jwtToken = jwtToken);
  }

  public getToken(): string {
    return this.jwtToken;
  }

  //added by bijay set other starter id
  public setStarter(newStarterId: any): void {
    this.starterId = newStarterId;
  }
  public checkInitialAuthentication(): authenticationTypes.ILoginResult {
    const item = window.localStorage.getItem(LOCALSTORAGE_AUTH);
    return item ? <authenticationTypes.ILoginResult>JSON.parse(item) : null;
  };

  public saveAuthentication(data: authenticationTypes.ILoginResult): void {
    window.localStorage.setItem(LOCALSTORAGE_AUTH, JSON.stringify(data));
  }

  public updateLocalAuthentication(data: any): any {
    const localItem: authenticationTypes.ILoginResult = this.checkInitialAuthentication();
    if (localItem) {
      /*const needUpdate: boolean = _.has(data, 'lastlogin') || _.has(data, 'token');
      if (_.has(data, 'lastlogin')) {
        localItem.lastlogin = data['lastlogin'];
      }
      if (_.has(data, 'token')) {
        localItem.token = data['token'];
      }*/

      let needUpdate: boolean = false;
      const dataKeys = ['lastlogin', 'token', 'MFAAuthenticatorOTP', 'MFAEmailOTP'];
      
      for (let i = 0; i < dataKeys.length; i++) {
        if (_.has(data, dataKeys[i])) {
          needUpdate = true;
          localItem[dataKeys[i]] = data[dataKeys[i]];
        }
      }

      if (needUpdate) {
        this.saveAuthentication(localItem);
      }

      if (_.has(data, 'message') && data.message !== '') {
        this.popNotification('info', '', data.message);
      }
    }
    return data;
  }

  protected authorizedHttpOptions(): RequestOptionsArgs {
    const headers = new Headers({
        authorization: `Bearer ${this.jwtToken}`
    });
    return new RequestOptions({headers: headers});
  }

  public handleError(errorCode: number, title: string, message: string, action: Action): void {
    //console.error('Something went wrong');
    if (message) {
      console.error(`[${title}]: ${message}`);
    }

    if (action) {
      this.store.dispatch({
        type: UNDO_ACTION,
        payload: action
      });
    }
    this.store.dispatch(new DisableBusyFlag({}));

    if (errorCode != 401) {
      this.popNotification('error', title, message);
      this.store.dispatch(go(['error']));
      // if (errorCode == 404 || errorCode == 500) {
      //   this.store.dispatch(go(['error'], {code: errorCode}));
      // } else {
      //   this.store.dispatch(go(['error']));
      // }
    } else {
      this.popNotification('error',
        message,
        '',
        true,
        () => {
          
          // clear cache and redirect user to login screen
          localStorage.removeItem(LOCALSTORAGE_AUTH);
          this.store.dispatch(new ServerLogoutAction({}));
          this.store.dispatch(go(['/authentication']));
        }
      );
    }
  }

  private popNotification(type: string, title: string, message: string, showCloseButton?: boolean, onHideCb?) {
    const toastrData: commonTypes.IToastr = {
        type: type,
        title: title,
        body: message,
        closeHtml: (showCloseButton) ? '<div class="btn btn-primary">Close</div>' : null,
        hideCb: (onHideCb) ? onHideCb : null
    };

    this.store.dispatch(new applicationActions.PopNotificationAction(toastrData));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/base-http.service.ts